import { useNavigate } from "react-router-dom";
import { useSupabaseQuery } from "@/hooks/useSupabaseQuery";
import { fetchTodaysSignalCount } from "@/features/dashboard/api";
import { StatCard } from "@/components/ui/StatCard";
import { Skeleton } from "@/components/ui/Skeleton";
import { formatCount } from "@/lib/format";

export function TodaysSignalsCard() {
  const navigate = useNavigate();
  const todayQuery = useSupabaseQuery(() => fetchTodaysSignalCount(), []);

  if (todayQuery.isLoading) {
    return (
      <div className="stat-card stat-card-clickable" role="link" tabIndex={0} onClick={() => navigate("/signals")}>
        <Skeleton width="80px" height="0.6875rem" />
        <Skeleton width="60px" height="1.5rem" />
      </div>
    );
  }

  const today = todayQuery.data?.today ?? 0;
  const yesterday = todayQuery.data?.yesterday ?? 0;
  const delta = yesterday > 0 ? ((today - yesterday) / yesterday) * 100 : undefined;

  return (
    <StatCard
      label="Today's signals"
      value={formatCount(today)}
      trendDelta={delta}
      onClick={() => navigate("/signals")}
    />
  );
}
